import { Link } from "react-router-dom";
import { deNom, useBranding } from "../../branding";
import { ButtonLink, cx } from "../../components";
import { useHeroTimeline, useLiensTransition, useParallax } from "../../motion";
import { ROUTES } from "../../shell";
import { VitrineLedger } from "./VitrineLedger";
import styles from "./Vitrine.module.css";

/**
 * Le héros : ce que fait le produit en deux lignes, la porte d'entrée, et le
 * grand livre qui se joue à côté. Le titre est découpé par lignes dans le JSX
 * pour que chaque ligne arrive à son tour — sans plugin de découpe.
 */
export function VitrineHero() {
  const lien = useLiensTransition();
  const section = useHeroTimeline<HTMLElement>();
  const decor = useParallax<HTMLDivElement>();
  const { esn_name, product_short } = useBranding();

  return (
    <section ref={section} id="accueil" className={cx(styles.sombre, styles.hero, styles.ecran)} aria-labelledby="hero-titre">
      <div ref={decor} className={styles.heroDecor} aria-hidden="true" />
      <div className={styles.heroGrille}>
        <div className={styles.heroTextes}>
          <p className={styles.surtitre} data-anim="hero">
            La plateforme de crédits prépayés {deNom(esn_name)}, pour ses clients
          </p>
          <h1 id="hero-titre" className={styles.heroTitre}>
            <span data-anim="hero">Vos prestations, payées d'avance.</span>
            <span data-anim="hero">Chaque token, tracé.</span>
          </h1>
          <p className={styles.heroChapo} data-anim="hero">
            {product_short} vend des packs de tokens à taux figé, réserve une enveloppe à chaque projet et consomme
            au réel sur les feuilles de temps des consultants. Le grand livre ne s'écrit qu'en ajout :
            rien ne se perd, tout se retrouve.
          </p>
          <div className={styles.heroActions} data-anim="hero">
            <ButtonLink to={ROUTES.inscription} variant="primary" size="lg" {...lien(ROUTES.inscription, "cube-avant")}>
              Créer un compte entreprise
            </ButtonLink>
            <ButtonLink to={ROUTES.connexion} variant="secondary" size="lg" {...lien(ROUTES.connexion, "cube-avant")}>
              Se connecter
            </ButtonLink>
          </div>
          <p className={styles.heroMention} data-anim="hero">
            Réservé aux entreprises clientes.{" "}
            <Link to="#inscription" className={styles.lienDiscret}>
              Comment ça se passe ?
            </Link>
          </p>
        </div>
        <div className={styles.heroVisuel} data-anim="hero-visual">
          <VitrineLedger />
        </div>
      </div>
      <a href="#etapes" className={styles.decouvrir}>
        Découvrir
        <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9l6 6 6-6" />
        </svg>
      </a>
    </section>
  );
}
